export default "__VITE_ASSET__DU$n$qja__"